import { render } from "./RestaurantsCreate.vue?vue&type=template&id=2c3cb916"
import script from "./RestaurantsCreate.vue?vue&type=script&lang=js"
export * from "./RestaurantsCreate.vue?vue&type=script&lang=js"

import "./RestaurantsCreate.vue?vue&type=style&index=0&id=2c3cb916&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__